
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[uid]",
      function () {
        return require("private-next-pages/event/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[uid]"])
      });
    }
  